import React from 'react';

const Footer = () => {
  return (
    <footer className="lg:text-[10px] text-[7px] flex justify-center bg-black py-5 items-center text-white text-center">
      <p>© 2024 tooClarity. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
